import { useEffect, useState } from 'react';
import { GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import { GridInitialState } from '@mui/x-data-grid-pro';
import { PageCard } from '../../../../Compounds/CardWithTitle/PageCard';
import {
  Commission,
  fetchCommissions,
  getCommissionLoadingSubject,
  getCommissionSubject,
  startSync
} from '../../../../../store/Commission';
import { getGridColumns, getInitialState } from '../../../../Compounds/UpstackDataGrid/helpers';
import { DefaultCommissionGridColumnDefs } from '../../ColumnDefs/CommissionGridColumnDefs';
import { TextSpan } from '../../../../Atoms/Text';
import { DEFAULT_DANGER_BUTTON_STYLE } from '../../../../../utils/styleHelpers';
import { UpstackDataGrid } from '../../../../Compounds/UpstackDataGrid/UpstackDataGrid';
import { useSnackbar } from '../../../../../Context/SnackbarContext';
import {
  getCustomizationSubject,
  getDefaultPreferences,
  GridPreferences
} from '../../../../../store/UserCustomizations';
import { ComponentSpinner } from '../../../../Compounds/Loading/ComponentSpinner';
import { PageLayout } from '../../../../PageLayout';

export const SyncTab = () => {
  const [commissions, setCommissions] = useState<Commission[]>([]);
  const [commissionColumns, setCommissionColumns] = useState<GridSingleSelectColDef[]>(DefaultCommissionGridColumnDefs);
  const [commissionLoading, setCommissionLoading] = useState<boolean>(false);
  const [gridSettings, setGridSettings] = useState<GridPreferences>(
    getDefaultPreferences().content['commissionGrid'] as GridPreferences
  );
  const [initialState, setInitialState] = useState<GridInitialState>();
  const { setSnack } = useSnackbar();

  useEffect(() => {
    const subscription = getCommissionSubject().subscribe((commissions) => {
      setCommissions(commissions);
      setCommissionColumns(getGridColumns(commissions, DefaultCommissionGridColumnDefs, 'commissionGrid'));
    });
    const userCustSub = getCustomizationSubject().subscribe((userCust) => {
      if (userCust) {
        setGridSettings(userCust.content.commissionGrid);
        const state = getInitialState(
          userCust.content.commissionGrid,
          DefaultCommissionGridColumnDefs,
          'commissionGrid'
        );
        setInitialState(state);
      }
    });

    const commissionLoadingSub = getCommissionLoadingSubject().subscribe((loadingState) =>
      setCommissionLoading(loadingState)
    );

    fetchCommissions();

    return () => {
      if (subscription) subscription.unsubscribe();
      if (userCustSub) userCustSub.unsubscribe();
      if (commissionLoadingSub) commissionLoadingSub.unsubscribe();
    };
  }, []);

  const pageActions = () => (
    <TextSpan className="flex items-center space-x-2">
      <button
        data-cy="start-sync-button"
        className={DEFAULT_DANGER_BUTTON_STYLE}
        onClick={() => {
          startSync();
          setSnack({ message: 'Sync started', type: 'success', open: true });
        }}>
        Sync Now
      </button>
    </TextSpan>
  );

  return (
    <PageLayout
      className="w-full"
      dataTestId="sync-page"
      dataCy="sync-page-card"
      pageTitle="">
      <PageCard
        dataTestId="rpm-sync-card"
        dataCy="rpm-sync-card"
        childrenWrapperClass="min-h-80 max-w-[60vw] min-w-full"
        title="RPM Sync"
        cardActions={pageActions()}>
        <>
          {!initialState ||
            (commissionLoading && (
              <div className="flex h-[45rem] m-auto">
                <ComponentSpinner label="Loading data..." />
              </div>
            ))}
          {initialState && !commissionLoading && (
            <UpstackDataGrid
              title="Commissions"
              rows={commissions}
              columns={commissionColumns}
              page="commissionGrid"
              gridSettings={gridSettings}
              showSearch={true}
              initialState={initialState}
              apiFilter={false}
              sxStyles={{ borderWidth: '0', borderBottomLeftRadius: '.75rem', borderBottomRightRadius: '.75rem' }}
            />
          )}
        </>
      </PageCard>
    </PageLayout>
  );
};
